import { render } from "./TheProfessionalExpedientCreate.vue?vue&type=template&id=0c58f261&ts=true"
import script from "./TheProfessionalExpedientCreate.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalExpedientCreate.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__